
<template>
  <route-bar
    size="small"
    :hasCache="true"
    headerTheme="dark"
    keepExclude="detail"
    :showHeader="showHeader"
  />
</template>

<script>
import native from '@/utils'
import RouteBar from '@/components/RouteBar'
import './helpCenter.scss'

const { appInfo } = native

export default {
  components: {
    RouteBar,
  },
  data() {
    return { showHeader: true }
  },
  async beforeCreate() {
    const search = window.location.search.slice(1)

    search.split('&').forEach((v) => {
      const [key, value] = v.split('=')
      if (key === 'keyword') {
        this.$router.replace({
          path: 'search',
          query: { keyword: unescape(decodeURI(value)) },
        })
      }
    })
  },
  mounted() {
    this.$store.dispatch('requestUserInfo')
    this.showHeader = !!(appInfo.key || appInfo.token)
  },
}
</script>



// WEBPACK FOOTER //
// src/views/help-center/HelpCenter.vue